import styled from "styled-components";
const TextAreaWithIcon = styled("textarea")<{ src: string }>`
  background: #000D30;
  background-image: url(${(props) => props.src});
  background-repeat: no-repeat;
  text-indent: 40px;
  border: 0.5px solid #ffffff90;
  border-radius: 12px;
  width: calc(100% - 40px);
  padding: 20px;
  font-family: "Spartan";
  background-position: 20px 15px;
  resize: none;
  ::placeholder{
    color: white;
  }
  color: white;
`;

export default TextAreaWithIcon;
